import { Transaction } from './types';

export const availableAmountCents = (transaction?: Transaction): number => {
  return (transaction?.availableAmountCents || 0) + (transaction?.availableFeeAmountCents || 0);
};
